<template>
  <Drawer :title="form.sandbox_name" :visible="visible" :before-close="close" width="480px">
    <template v-slot:default>
      <div class="main">
        <div class="content">
          <div class="content_group">
            <div class="content_item">
              <div class="content_item_title">名称</div>
              <div class="content_item_message">{{ form.sandbox_name }}</div>
            </div>
            <div class="content_item">
              <div class="content_item_title">Sandbox类型</div>
              <div class="content_item_message">{{ form.sandbox_type }}</div>
            </div>
            <div class="content_item">
              <div class="content_item_title">描述</div>
              <div class="content_item_message">{{ form.desc }}</div>
            </div>
            <div class="content_item">
              <div class="content_item_title">更新人</div>
              <div class="content_item_message">{{ form.update_by }}</div>
            </div>
            <div class="content_item">
              <div class="content_item_title">更新时间</div>
              <div class="content_item_message">{{ form.update_time }}</div>
            </div>
            <div class="content_item">
              <div class="content_item_title">应用模板</div>
              <div class="content_item_message">
                {{ form.sandbox_tmpl_id !== '0' ? form.sandbox_tmpl_name : '-' }}
              </div>
            </div>
            <div class="content_item">
              <div class="content_item_title">脱敏规则</div>
            </div>
            <div @click.stop="openJsonEdit()" style="width: 500px">
              <div class="json-editor">
                {{ form.sandbox_tmpl_id !== '0' ? templateObject.desensitize_rule : '{}' }}
              </div>
              <div class="tips">(点击进入详情)</div>
            </div>
            <div class="content_item">
              <div class="content_item_title">同步对象表</div>
              <div class="content_item_message" v-if="form.sandbox_tmpl_id !== '0'">
                <el-tag v-for="(item, index) in templateObject.sync_objects" :key="index">
                  {{ item }}
                </el-tag>
              </div>
            </div>
          </div>
        </div>
      </div>
      <json-edit
        v-if="showJson"
        type="view"
        :show-json="showJson"
        :json="jsonData"
        title="发布的流程配置"
        @cancel="showJson = false"
      />
    </template>
    <template v-slot:footer>
      <el-button class="drawer-footer-btn" @click="close">关闭</el-button>
      <el-button
        class="drawer-footer-btn"
        @click="edit"
        v-if="jurisdiction.updateManage_sandbox_edit"
      >
        编辑
      </el-button>
    </template>
  </Drawer>
</template>

<script>
import Drawer from '@/components/drawer';
import jsonEdit from '@/components/jsonEdit/index.vue';
import _ from 'lodash';
export default {
  name: 'SandBoxItem',
  components: { Drawer, jsonEdit },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
    operateType: {
      type: String,
      default: 'add',
    },
    jurisdiction: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        name: '',
        sandbox_type: '',
        sandbox_tmpl_id: '',
        desc: '',
        sandbox_name: '',
      },
      templateOptions: [],
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'submit' }],
        sandbox_type: [{ required: true, message: '请选择类型', trigger: 'submit' }],
        sandbox_tmpl_id: [{ required: false, message: '请选择应用模版', trigger: 'submit' }],
      },
      templateObject: {},
      jsonData: {},
      showJson: false,
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        console.log('%c Line:110 🍕 this.row', 'color:#e41a6a', this.row);
        this.form = _.cloneDeep(this.row);
        if (this.row.sandbox_tmpl_id !== '0') {
          this.$request({
            url: this.$api.getSandboxTemplate,
            data: {
              id: Number(this.row.sandbox_tmpl_id),
            },
          })
            .then((res) => {
              this.templateObject.desensitize_rule = res?.data?.desensitize_rule;
              this.templateObject.sync_objects = res?.data?.sync_objects;
              this.jsonData = res?.data?.desensitize_rule;
              this.$forceUpdate();
            })
            .catch((err) => {
              console.log('%c Line:126 🍊 err', 'color:#b03734', err);
              this.templateObject.desensitize_rule = '{}';
              this.templateObject.sync_objects = [];
              this.jsonData = '{}';
              this.$forceUpdate();
            });
        }
      }
    },
    form: {
      handler(newVal) {
        console.log('%c Line:99 🧀 this.form.sandbox_type', 'color:#6ec1c2', newVal);
        if (newVal.sandbox_type === 'partial') {
          this.rules.sandbox_tmpl_id = [
            { required: true, message: '请选择应用模版', trigger: 'submit' },
          ];
          // 重新验证 B 字段
          this.$refs.form.validateField('sandbox_tmpl_id');
        } else {
          this.rules.sandbox_tmpl_id = [];
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getAllSandboxTemplate();
  },
  methods: {
    getAllSandboxTemplate() {
      this.$request({
        url: this.$api.getAllSandboxTemplate,
        data: {},
      }).then((res) => {
        console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
        this.templateOptions = res.list;
      });
    },
    openJsonEdit() {
      this.showJson = true;
    },
    close() {
      this.$emit('close');
    },
    edit() {
      this.$emit('close');
      this.$emit('editSandBox', this.row);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/button.scss';

.container {
  .row {
    margin-bottom: 8px;
    display: flex;
    .title {
      color: #98a2b2;
    }
    .text {
      flex: 1;
    }
  }
}
.drawer-footer-btn {
  margin-left: 8px;
}
.main {
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
  .content {
    display: flex;
    min-width: 448px;
    max-width: 688px;
    padding: 0px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1 0 0;
    &_group {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      align-self: stretch;
      .content_item {
        display: flex;
        max-width: 788px;
        padding: 4px 0px;
        // margin-top: 14px;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        &_title {
          display: flex;
          flex-direction: column;
          height: 22px;
          align-items: flex-start;
          align-self: stretch;
          color: #708091;
          font-feature-settings: 'liga' off, 'clig' off;
          font-family: var(--Family-, 'Microsoft YaHei UI');
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
        }
        &_message {
          display: flex;
          padding: var(--Spacing-2, 2px) var(--Spacing-0, 0px);
          align-items: flex-start;
          align-content: flex-start;
          gap: var(--Spacing-0, 0px) var(--Spacing-8, 8px);
          align-self: stretch;
          flex-wrap: wrap;
          color: var(--Text-Neutral-default, #151b22);
          font-feature-settings: 'liga' off, 'clig' off;

          /* ToB 中文/T1 14px Regular(400)-正文 */
          font-family: 'Microsoft YaHei UI';
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 157.143% */
        }
      }
    }
  }
}
.json-editor {
  background: #e5eaf2;
  height: 200px;
  width: 100%;
  overflow-x: scroll;
  overflow-y: scroll;
  cursor: pointer;
  line-height: 32px;
}
</style>
